import { render, staticRenderFns } from "./tooltipsJSON.vue?vue&type=template&id=74c5df06"
import script from "./tooltipsJSON.vue?vue&type=script&lang=js"
export * from "./tooltipsJSON.vue?vue&type=script&lang=js"
import style0 from "./tooltipsJSON.vue?vue&type=style&index=0&id=74c5df06&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports